module.exports = __webpack_public_path__ + "static/staff-john-4-9bc407605c2f1c005d7ad4732b26931c.png";